module.exports = __webpack_public_path__ + "static/media/Chevron.840a8df6.svg";